import { DateTime } from 'luxon';
import { Months } from 'context';
import { getMonthsTranslated } from 'services/TranslationService';
import { appLanguage } from 'services/appLanguage';

export const parseDate = (date: string) =>
  `${DateTime.fromISO(date).day} ${getMonthsTranslated(
    Months[DateTime.fromISO(date, { locale: 'eng' }).monthLong as keyof typeof Months],
  )} ${DateTime.fromISO(date).year}, ${DateTime.fromISO(date).toLocaleString(
    DateTime.TIME_24_SIMPLE,
  )}`;

/**
 * Дата БЕЗ времени: «6 Wrzesień 2026».
 *
 * `parseDate` дописывает время, и для полей вида «активна до» это выглядело
 * ошибкой — у срока действия вакансии времени в данных нет вовсе
 * (`Vacancy.expires_at` — DateField), поэтому «00:00» было чистым артефактом.
 */
export const parseDateOnly = (date: string) =>
  `${DateTime.fromISO(date).day} ${getMonthsTranslated(
    Months[DateTime.fromISO(date, { locale: 'eng' }).monthLong as keyof typeof Months],
  )} ${DateTime.fromISO(date).year}`;

/**
 * Дата словами на языке интерфейса: «15 września 2026» / «15 сентября 2026».
 *
 * ТЗ 0071: карьерный раздел выводил сырые `2026-09-15` и
 * `toLocaleDateString()` без локали — в англоязычном браузере «9/15/2026».
 * `parseDateOnly` здесь не годится: он склеивает именительный падеж месяца
 * («6 Wrzesień 2026»), а по-польски и по-русски после числа нужен родительный.
 * Пустое или нечитаемое значение — пустая строка, а не «Invalid DateTime».
 */
export const formatCareerDate = (value: string | null | undefined): string => {
  if (!value) return '';
  const parsed = DateTime.fromISO(value);
  if (!parsed.isValid) return '';
  return parsed
    .setLocale(appLanguage())
    .toLocaleString({ day: 'numeric', month: 'long', year: 'numeric' });
};

export const parseDateFromDatePicker = (date: Date) =>
  `${DateTime.fromJSDate(date).day} ${getMonthsTranslated(
    Months[
      DateTime.fromISO(DateTime.fromJSDate(date).toISODate(), { locale: 'eng' })
        .monthLong as keyof typeof Months
    ],
  )} ${DateTime.fromJSDate(date).year}`;

const date = new Date();

export default date;
